module.exports = __webpack_public_path__ + "img/dona.5893a1a3.png";